module.exports = __webpack_public_path__ + "img/02.046f5e7d.jpg";